export const ACTUATOR_KIND_INFO_TEXT =
  "motor — direct force/torque; control signal is applied force\n" +
  "position — PD controller; tracks a target angle using kp + damping\n" +
  "velocity — tracks a target joint velocity using kv gain\n" +
  "intvelocity — integrates velocity commands into a position target\n" +
  "general — fully manual; configure gain/bias/dynamics explicitly";

export const ACTUATOR_CONTROL_SECTION_INFO = Object.freeze({
  joints:
    "Direct joint position controls for hinge and slide joints. When physics is running, use actuator controls instead.",
  motors:
    "motor — direct force/torque; control signal is applied force\n" +
    "velocity — tracks a target joint velocity using kv gain\n" +
    "intvelocity — integrates velocity commands into a position target",
  positions:
    "position — PD controller; tracks a target angle using kp + damping\n" +
    "general — fully manual; configure gain/bias/dynamics explicitly",
});
